import clsx from 'clsx';
import styles from './Stat.module.css';

/**
 * Tank Redesign Stat atom — labelled big-number tile.
 *
 * Source: ~/Downloads/tank-redesign/tokens.jsx → `Stat` function.
 * Used on Overview tiles + Statistics tabs. Mono uppercase label on top,
 * 22px display number below. When `active`, the tile picks up the named
 * status state's color + tinted background.
 *
 * @param {Object} props
 * @param {string} props.label
 * @param {React.ReactNode} props.value
 * @param {'pending'|'attention'|'done'|'exported'|'error'|'skipped'} [props.kind='pending']
 * @param {boolean} [props.active=false]
 * @param {string} [props.className]
 */
export default function Stat({ label, value, kind = 'pending', active = false, className }) {
  return (
    <div
      className={clsx(
        styles.stat,
        styles[`kind-${kind}`],
        active && styles.active,
        className
      )}
    >
      <div className={styles.label}>{label}</div>
      <div className={styles.value}>{value}</div>
    </div>
  );
}
